import React, { useEffect, useState } from "react";
import { UserDataGet } from "../../Api/CoreApi";
import { Table, Tag } from "antd";
import {
  FaArrowAltCircleUp,
  FaArrowAltCircleDown,
  FaHeart,
  FaInbox,
  FaPaperPlane,
  FaPhoneAlt,
  FaInfoCircle,
} from "react-icons/fa";
import "../User_Panel/User_Apply.css";
import { useNavigate } from "react-router-dom";
import ProfileHeader from "./Profile_Header";
import Footer from "../../Home_Page_WLog/Footer/Footer";

function User_Apply() {
  const Navigate = useNavigate();
  const id = localStorage.getItem("user_id");
  const [user_applyout, setUser_Applyout] = useState([]);
  const [user_applyin, setUser_Applyin] = useState([]);
  const [pop, setPop] = useState(0);

  const user_role = localStorage.getItem("role");

  const permission = () => {
    if (user_role === null || user_role != "user") {
      Navigate("/");
    }
  };

  const get = async () => {
    const response = await UserDataGet();

    // Filter current user
    const filter_currentuser = response.filter(
      (user) =>
        Array.isArray(user.user_apply) &&
        user.user_apply.some((app) => app.suser_id === id)
    );
    setUser_Applyout(filter_currentuser);

    // Filter user apply
    const filter_user_apply = response.filter((i) => i.User_id === id);

    if (filter_user_apply.length === 0) {
      setUser_Applyin([]);
      return;
    }

    const map_suser_id = filter_user_apply.map((i) => i.user_apply);
    const userApplyArray = map_suser_id[0] || [];
    const map_suser_id1 = userApplyArray.map((i) => i.suser_id);

    const filter_allUser = response.filter((i) =>
      map_suser_id1.includes(i.User_id)
    );
    setUser_Applyin(filter_allUser);
  };

  useEffect(() => {
    permission();
    get();
  }, []);

  const columns = [
    {
      title: "No.",
      key: "index",
      render: (text, record, index) => (
        <span className="ua-row-index">{index + 1}</span>
      ),
      width: 70,
    },
    {
      title: "Firstname",
      dataIndex: "firstname",
      key: "firstname",
      render: (text, record) => (
        <div className="ua-name-cell">
          <div className="ua-avatar-circle">
            {record.firstname ? record.firstname.charAt(0).toUpperCase() : "U"}
          </div>
          <span>{record.firstname || "N/A"}</span>
        </div>
      ),
    },
    {
      title: "Caste",
      dataIndex: "caste",
      key: "caste",
      render: (value) => <span className="ua-chip">{value || "N/A"}</span>,
    },
    {
      title: "District",
      dataIndex: "district",
      key: "district",
      render: (value) => <span>{value || "N/A"}</span>,
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      render: (value) => <span>{value || "N/A"}</span>,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <div className="ua-action-group">
          <a href={`tel:${record.contact}`}>
            <button className="ua-action-btn call-btn">
              <FaPhoneAlt /> Call
            </button>
          </a>
          <a
            href={`https://communityrishtey.com/User_Data/${record.User_id}`}
            rel="noopener noreferrer"
          >
            <button className="ua-action-btn details-btn">
              <FaInfoCircle /> Details
            </button>
          </a>
        </div>
      ),
    },
  ];

  return (
    <>
      <ProfileHeader />

      <div className="user-apply-page">
        {/* Background decorations */}
        <div className="ua-floating-wrap">
          {["💖", "💌", "💕", "🌹", "✨", "❤️", "🎀", "💗"].map((item, index) => (
            <span key={index} className={`ua-float ua-float-${index}`}>
              {item}
            </span>
          ))}
        </div>

        {/* Hero */}
        <section className="user-apply-hero">
          <div className="ua-hero-overlay"></div>
          <div className="ua-hero-content">
            <div className="ua-badge">
              <FaHeart />
              Your Matrimony Requests
            </div>

            <h1 className="ua-main-title">
              Manage Your <span>Connections</span>
            </h1>

            <p className="ua-subtitle">
              Track the profiles you have applied to and those who have shown
              interest in you — all in one secure and elegant space.
            </p>
          </div>
        </section>

        {/* Summary */}
        <section className="ua-summary-section">
          <div className="ua-summary-grid">
            <div className="ua-summary-card sent">
              <div className="ua-summary-icon">
                <FaPaperPlane />
              </div>
              <div>
                <h3>Sent Requests</h3>
                <p>{user_applyout.length}</p>
              </div>
            </div>

            <div className="ua-summary-card received">
              <div className="ua-summary-icon">
                <FaInbox />
              </div>
              <div>
                <h3>Received Requests</h3>
                <p>{user_applyin.length}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Toggle Buttons */}
        <section className="ua-toggle-section">
          <div className="ua-toggle-wrap">
            <button
              className={`ua-toggle-btn ${pop === 0 ? "active sent" : ""}`}
              onClick={() => setPop(0)}
            >
              <FaArrowAltCircleUp />
              <span>Sent Requests</span>
              <strong>{user_applyout.length}</strong>
            </button>

            <button
              className={`ua-toggle-btn ${pop === 1 ? "active received" : ""}`}
              onClick={() => setPop(1)}
            >
              <FaArrowAltCircleDown />
              <span>Received Requests</span>
              <strong>{user_applyin.length}</strong>
            </button>
          </div>
        </section>

        {/* Table Section */}
        <section className="ua-table-section">
          {pop === 0 && (
            <div className="ua-table-card">
              <div className="ua-table-topbar sent"></div>
              <div className="ua-table-header">
                <h2>Sent Requests</h2>
                <p>Profiles you have shown interest in</p>
              </div>
              <Table
                columns={columns}
                dataSource={user_applyout}
                rowKey={(record) => record.id || record.contact}
                pagination={false}
                scroll={{ x: "100%" }}
                className="ua-custom-table"
                locale={{
                  emptyText: (
                    <div className="ua-empty-state">
                      <span className="ua-empty-icon">💌</span>
                      <h3>No Sent Requests</h3>
                      <p>You haven’t applied to any profiles yet.</p>
                    </div>
                  ),
                }}
              />
            </div>
          )}

          {pop === 1 && (
            <div className="ua-table-card">
              <div className="ua-table-topbar received"></div>
              <div className="ua-table-header">
                <h2>Received Requests</h2>
                <p>Profiles that have shown interest in you</p>
              </div>
              <Table
                columns={columns}
                dataSource={user_applyin}
                rowKey={(record) => record.id || record.contact}
                pagination={false}
                scroll={{ x: "100%" }}
                className="ua-custom-table"
                locale={{
                  emptyText: (
                    <div className="ua-empty-state">
                      <span className="ua-empty-icon">💕</span>
                      <h3>No Received Requests</h3>
                      <p>No one has applied to your profile yet.</p>
                    </div>
                  ),
                }}
              />
            </div>
          )}
        </section>
      </div>

      <Footer />
    </>
  );
}

export default User_Apply;